import { render, staticRenderFns } from "./ItineraryDetailPanel.vue?vue&type=template&id=6e79bc30&scoped=true&"
import script from "./ItineraryDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ItineraryDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDetailPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ItineraryDetailPanel.vue?vue&type=style&index=1&id=6e79bc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79bc30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VSpacer,VToolbar})
